import React from 'react';
import { useTheme } from 'styled-components/macro';
import { NewModal } from 'lib/components';
import { Button } from 'react-covideo-common';
import { Folder } from 'lib/api/folders/getFolders';
import { ParagraphNormal15 } from 'lib/components/styles/typography';
import { Flex } from 'lib/components/styles/layout';
import { MdPerson } from 'react-icons/md';
import { FOLDER_SHARED_AS } from 'app/pages/library/videos/videoList/components/types';
import { useTranslation } from 'react-i18next';

type Props = {
  handleModalClose: () => void;
  openOemFolderShareModal: () => void;
  openFolderShareModal: () => void;
  currentFolder?: Folder;
};

export const AdminSelectionModal = ({
  handleModalClose,
  openOemFolderShareModal,
  openFolderShareModal,
}: Props) => {
  const [selectedAction, setSelectedAction] =
    React.useState<FOLDER_SHARED_AS | null>(null);
  const themes = useTheme();
  const { t } = useTranslation();
  const buttonStyles = {
    height: '112px',
    maxHeight: '112px',
    width: '50%',
    border: '1px solid #E9EAEA',
    boxShadow: '0 4px 12px 0 #1d1e240a',
    borderRadius: '8px',
    padding: '20px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  };

  return (
    <NewModal
      headerText={t('Share Folder As')}
      closeModalOnBackdropOrEscPress={true}
      closeModal={() => handleModalClose()}
      headerMargin='0 0 0 0'
      style={{
        content: {
          padding: '24px 24px 16px 24px',
          minWidth: 'auto',
          paddingLeft: '32px',
          width: '592px',
          maxWidth: '592px',
        },
      }}
    >
      <Flex gap='29px' flexDirection='column'>
        <Flex padding='16px 0 0 0'>
          <ParagraphNormal15 color={themes.colors.neutral[80]}>
            {t('Please choose the role you want to use to share the folder.')}
          </ParagraphNormal15>
        </Flex>
        <Flex flexDirection='row' gap='22px' height='112px' alignItems='center'>
          <Button
            text={t('OEM Admin')}
            icon={<MdPerson size={24} />}
            variant='transparent'
            style={{
              ...buttonStyles,
              flexDirection: 'column-reverse',
              backgroundColor:
                !!selectedAction &&
                selectedAction === FOLDER_SHARED_AS.OEM_ADMIN
                  ? themes.colors.neutral[10]
                  : themes.colors.white[100],
            }}
            onClick={() => setSelectedAction(FOLDER_SHARED_AS.OEM_ADMIN)}
          />
          <Button
            text={t('Organization / Standard Admin')}
            icon={<MdPerson size={24} />}
            variant='transparent'
            style={{
              ...buttonStyles,
              flexDirection: 'column-reverse',
              backgroundColor:
                !!selectedAction &&
                selectedAction === FOLDER_SHARED_AS.COMPANY_ADMIN
                  ? themes.colors.neutral[10]
                  : themes.colors.white[100],
            }}
            extendStyles={{
              container: {},
              text: {
                whiteSpace: 'break-spaces',
                textOverflow: 'ellipsis',
                width: '100%',
              },
            }}
            onClick={() => setSelectedAction(FOLDER_SHARED_AS.COMPANY_ADMIN)}
          />
        </Flex>
        <Flex
          flexDirection='row'
          margin='32px 0 0 0'
          alignItems='center'
          justifyContent='flex-end'
          gap='12px'
        >
          <Button
            onClick={async () => handleModalClose()}
            variant='secondary'
            text={t('Close')}
          />
          <Button
            text={t('Proceed to Share')}
            variant='primary'
            onClick={() => {
              if (selectedAction === FOLDER_SHARED_AS.OEM_ADMIN) {
                openOemFolderShareModal();
              } else if (selectedAction === FOLDER_SHARED_AS.COMPANY_ADMIN) {
                openFolderShareModal();
              }
              handleModalClose();
            }}
            disabled={!selectedAction}
          />
        </Flex>
      </Flex>
    </NewModal>
  );
};
